var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"matrix-video"},[_c('div',{staticClass:"content",on:{"click":function($event){return _vm.showVideoPlayer(_vm.video)}}},[_c('video',{staticClass:"video-js",staticStyle:{"margin":"auto"},attrs:{"id":`video${_vm.video.id}`,"webkit-playsinline":"true","muted":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }